import { makeStyles } from '@mui/styles';
import { colors, fontWeight } from '../../../../packages';

export const sxStyles = {
  drawer: {
    '& .drawerBody': {
      padding: 0,
    },
  },
  wrapper: {
    flex: 1,
    justifyItems: 'space-between',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '80px',
    padding: '20px 16px',
    borderBottom: `1px solid ${colors.neutral100}`,
  },
  backBtn: {
    width: '40px',
    height: '40px',
    minWidth: '40px',
  },
  formContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 'calc(100vh - 160px)',
    gap: '24px',
    padding: '40px',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    position: 'relative',
  },
  errorContainer: {
    padding: '12px 40px',
    backgroundColor: colors.destructive50,
    borderLeft: `3px solid ${colors.destructive500}`,
    margin: '0',
    '& span': {
      color: colors.destructive700 || colors.destructive500,
      fontSize: '14px',
      fontWeight: fontWeight.MEDIUM,
      lineHeight: '20px',
    },
  },
  footer: {
    display: 'flex',
    bottom: 0,
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '80px',
    padding: '16px',
    borderTop: `1px solid ${colors.neutral100}`,
  },
};

export const useStyles = makeStyles({
  headerTitle: {
    fontSize: '24px',
    lineHeight: '32px',
    fontWeight: fontWeight.BOLD,
  },
  label: {
    fontSize: 14,
    lineHeight: '20px',
    margin: 0,
  },
  form: {
    flex: 1,
  },
});
